module.exports = __webpack_public_path__ + "img/logo-px.32f3fb3b.png";